(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ax-product-accordion"] && !Shopify.designMode) return;
  try {
    // Le widget d'avis se charge après l'ouverture et allonge la colonne, qui peut alors cesser de
  // coller : la ligne se décale. On la recale une fois en haut quand il arrive, sauf si le visiteur
  // a défilé entre-temps.
  const recalerAvis = (details) => {
    const content = details.querySelector('.ax-product-accordion__content');
    if (!content) return;

    const startHeight = content.offsetHeight;
    const controller = new AbortController();
    const observer = new ResizeObserver(() => {
      if (content.offsetHeight - startHeight < 200) return;
      stop();
      details.scrollIntoView({ block: 'start' });
    });
    const stop = () => {
      observer.disconnect();
      controller.abort();
    };

    observer.observe(content);
    for (const type of ['wheel', 'touchstart', 'keydown']) {
      window.addEventListener(type, stop, { once: true, passive: true, signal: controller.signal });
    }
    setTimeout(stop, 8000);
  };

  const ouvrirAvis = (comportement) => {
    const details = document.querySelector('.ax-product-accordion__item--reviews');
    if (!details) return false;
    details.open = true;
    details.querySelector('summary')?.focus({ preventScroll: true });
    details.scrollIntoView({ behavior: comportement, block: 'start' });
    recalerAvis(details);
    return true;
  };

  document.addEventListener('click', (event) => {
    const lien = event.target.closest?.('a[href="#avis-verifies"]');
    if (lien && ouvrirAvis('smooth')) event.preventDefault();
  });

  // Arrivée directe sur l'ancre : après les modules de la page (dont ax-sticky-details.js, qui doit
  // suivre le défilement), exécutés avant DOMContentLoaded.
  if (location.hash === '#avis-verifies') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => ouvrirAvis('auto'), { once: true });
    } else {
      ouvrirAvis('auto');
    }
  }
  } catch(e) { console.error(e); }
})();

})();
